import React, { ReactNode } from 'react';
import { Icon } from '../icon';
import { t } from '../../locales/i18n';
import { Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import { SemanticICONS } from 'semantic-ui-react/dist/commonjs/generic';
import { colors } from '@nextinq/ui-toolkit';
import { sizes } from '../../themes/sizes';

const Trigger = styled.a`
  padding: ${sizes.margins.large};
  cursor: help;
  &,
  &:visited {
    color: ${colors.grey.grey};
  }
  &:hover,
  &:focus {
    color: ${colors.grey.greyLighter};
  }
`;
const Container = styled.section``;
const Label = styled.section``;
const Title = styled.section``;
const Subtitle = styled.section``;

export interface TooltipProps {
  tipKey?: string;
  triggerIconName?: SemanticICONS;
  title?: string;
  subtitle?: string;
  label?: string;
  children?: ReactNode;
}

export function Tooltip(props: TooltipProps) {
  const { tipKey, title, label, subtitle, children, triggerIconName } = props;
  const iconName = triggerIconName || 'help circle';

  if (tipKey) {
    return (
      <Popup
        closeOnEscape
        closeOnTriggerMouseLeave={false}
        openOnTriggerMouseEnter={false}
        content={tipKey && t(`tip.${tipKey}`)}
        trigger={
          <Trigger>
            <Icon name={iconName} />
          </Trigger>
        }
      />
    );
  }
  if (children) {
    return (
      <Popup
        closeOnEscape
        closeOnTriggerMouseLeave={false}
        openOnTriggerMouseEnter={false}
        content={tipKey && t(`tip.${tipKey}`)}
        trigger={
          <Trigger>
            <Icon name={iconName} />
          </Trigger>
        }
      >
        {children}
      </Popup>
    );
  }
  return (
    <Popup
      trigger={
        <Trigger>
          <Icon name={iconName} />
        </Trigger>
      }
    >
      <Container>
        <Label>{label}</Label>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Container>
    </Popup>
  );
}
